import { LAYERS } from '@/features/heat-project/constants';

export default [
  {
    id: 'gl-draw-point-heat-source',
    type: 'circle',
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
      ['==', 'user_type', LAYERS.HEAT_SOURCE_POINT],
    ],
    paint: {
      'circle-radius': [
        'interpolate',
        ['exponential', 0.5],
        ['zoom'],
        15,
        3,
        18,
        5,
      ],
      'circle-color': 'rgb(255,255,255)',
      'circle-stroke-width': 4,
      'circle-stroke-color': [
        'case',
        ['get', 'user_isConnected'],
        '#8200ad',
        'rgba(209,75,255,0.57)',
      ],
    },
  },
  {
    id: 'gl-draw-point-home',
    type: 'circle',
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
      ['==', 'active', 'false'],
      ['==', 'user_type', LAYERS.HOME_CONNECTION_POINT],
    ],
    paint: {
      'circle-radius': [
        'interpolate',
        ['exponential', 0.5],
        ['zoom'],
        15,
        1,
        18,
        3,
      ],
      'circle-color': 'rgb(255,255,255)',
      'circle-stroke-width': 2,
      'circle-stroke-color': [
        'case',
        ['get', 'user_isConnected'],
        '#0692BC',
        'rgba(114,184,234,0.66)',
      ],
    },
  },
  {
    id: 'gl-draw-point-home-active',
    type: 'circle',
    filter: [
      'all',
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
      ['==', 'active', 'true'],
      ['==', 'user_type', LAYERS.HOME_CONNECTION_POINT],
    ],
    paint: {
      'circle-radius': [
        'interpolate',
        ['exponential', 0.5],
        ['zoom'],
        15,
        1,
        18,
        3,
      ],
      'circle-color': 'rgb(255,255,255)',
      'circle-stroke-width': 2,
      'circle-stroke-color': '#f35d2f',
    },
  },
  {
    id: 'gl-draw-line-deactive',
    type: 'line',
    filter: [
      'all',
      ['==', 'active', 'false'],
      ['==', '$type', 'LineString'],
      ['!=', 'mode', 'static'],
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': [
        'match',
        ['get', 'user_type'],
        LAYERS.DISTRIBUTION_NETWORK,
        '#60bdff',
        LAYERS.HOME_CONNECTION,
        '#ff9500',
        LAYERS.HEAT_SOURCE_CONNECTION,
        '#a238f8',
        '#0692BC',
      ],
      'line-dasharray': [0.2, 2],
      'line-width': 2,
    },
  },
  {
    id: 'gl-draw-line-active',
    type: 'line',
    filter: [
      'all',
      ['==', 'active', 'true'],
      ['==', '$type', 'LineString'],
      ['!=', 'mode', 'static'],
    ],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#f35d2f',
      'line-dasharray': [0.2, 2],
      'line-width': 2,
    },
  },
  // polygon fill
  {
    id: 'gl-draw-polygon-fill',
    type: 'fill',
    filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
    paint: {
      'fill-color': '#0692BC',
      'fill-outline-color': '#0692BC',
      'fill-opacity': 0.1,
    },
  },
  // polygon outline stroke
  // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
  {
    id: 'gl-draw-polygon-stroke-active',
    type: 'line',
    filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
    layout: {
      'line-cap': 'round',
      'line-join': 'round',
    },
    paint: {
      'line-color': '#0692BC',
      'line-dasharray': [0.2, 2],
      'line-width': 2,
    },
  },
  // vertex point halos
  {
    id: 'gl-draw-polygon-and-line-vertex-halo-active',
    type: 'circle',
    filter: [
      'all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
    ],
    paint: {
      'circle-radius': 5,
      'circle-color': '#0692BC',
    },
  },
  // vertex points
  {
    id: 'gl-draw-polygon-and-line-vertex-active',
    type: 'circle',
    filter: [
      'all',
      ['==', 'meta', 'vertex'],
      ['==', '$type', 'Point'],
      ['!=', 'mode', 'static'],
    ],
    paint: {
      'circle-radius': 3,
      'circle-color': '#ffffff',
    },
  },
];
